import { render, staticRenderFns } from "./UpdateHallContainer.vue?vue&type=template&id=2fbe6e1a"
import script from "./UpdateHallContainer.vue?vue&type=script&lang=js"
export * from "./UpdateHallContainer.vue?vue&type=script&lang=js"
import style0 from "./UpdateHallContainer.vue?vue&type=style&index=0&id=2fbe6e1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports